export default function Footer() {
  const linkGroups = [
    {
      title: '漫画分类',
      links: ['热血少年', '恋爱甜宠', '悬疑推理', '异世界', '国漫精品'],
    },
    {
      title: '关于我们',
      links: ['平台介绍', '更新公告', '投稿合作', '用户协议', '隐私政策'],
    },
    {
      title: '帮助中心',
      links: ['常见问答', '阅读指南', 'APP下载', '意见反馈', '版权投诉'],
    },
  ];

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 cursor-pointer no-underline">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-lg text-background-50"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">漫漫漫画</span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              漫漫漫画——汇集海量免费漫画和漫画全集，支持免费看漫画、漫画大全，覆盖韩漫日漫国漫，下拉式流畅阅读，轻松追更不花钱。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors duration-200 cursor-pointer no-underline">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors duration-200 cursor-pointer no-underline">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors duration-200 cursor-pointer no-underline">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link}>
                    <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer no-underline">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-4">
            <p className="text-xs text-background-500">
              © 2026 漫漫漫画 manmancomic.com — 本站所有漫画内容均来自互联网，版权归原作者所有
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer no-underline">用户协议</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer no-underline">隐私政策</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer no-underline">版权声明</a>
            </div>
          </div>
          <div className="text-center">
            <h4 className="text-xs font-semibold text-background-500 mb-2">合作伙伴</h4>
            <p className="text-xs text-background-600">更多合作伙伴即将入驻，敬请期待</p>
          </div>
        </div>
      </div>
    </footer>
  );
}